import { ColumnDef } from '@tanstack/react-table';
import { FileExplorerCkeckbox } from './FileExplorerCkeckbox';
import { FileExplorerNameCell } from './FileExplorerNameCell';
import { ColumnType } from './types';

export const getStaticColumns = <TData,>(): Record<
  ColumnType,
  ColumnDef<TData>
> => ({
  [ColumnType.Select]: {
    id: ColumnType.Select,
    header: 'Select',
    size: 50,
    meta: { align: 'center' },
    cell: FileExplorerCkeckbox,
  },
  [ColumnType.Name]: {
    id: ColumnType.Name,
    header: 'File Name',
    size: 300,
    cell: FileExplorerNameCell,
  },
});
